import React, {
  Fragment,
  useEffect,
  useState
} from "react";
import {
  FormGroup,
  Input,
  Label,
  Button,
  Form,
  FormFeedback
} from "reactstrap";
import { connect } from "react-redux";
import { clearUpdateGroupError, updateGroup } from "../../../store/deviceDetails/actions.js";
import Message from "../../../CommonData/Data/Message.js";
import { updateForm } from "../../../store/form/actions.js";
import { getAssignableGroupsForAsyncSelect } from "../../../store/device/actions.js";

const UpdateGroupForm = (props) => {

  const { handleClose, errorMessage, form } = props;
  const [groupDetails, setGroupDetails] = useState();

  useEffect(() => {
    const { selectedGroup } = props;
    if (selectedGroup) {
      setGroupDetails({
        ...selectedGroup,
        value: selectedGroup.groupId,
        label: selectedGroup.groupName ?? "",
      });
      props.updateForm({
        formEditGroup: {
          ...selectedGroup,
          groupId: selectedGroup.groupId,
          groupName: selectedGroup.groupName ?? "",
          groupNo: selectedGroup.groupNo ?? "",
        },
        errors: {}
      })
    }
    props.clearUpdateGroupError();

    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);


  const AddGroupChange = (e) => {
    const { name, value } = e.target;
    setGroupDetails(value);
    props.updateForm({
      formEditGroup: {
        ...form.formEditGroup,
        groupName: value
      },
      errors: {
        ...form && form.errors,
        groupName: null,
      }
    });
  }

  const handleUpdateGroup = (e) => {
    e.preventDefault();
    const { masterDeviceDetails } = props;
    const { formEditGroup } = form || {};
    const { groupName } = formEditGroup || {};
    const currentErrors = {};

    if (!groupName) {
      currentErrors.groupName = "Group name is required"
    }
    props.updateForm({
      formEditGroup: {
        ...form.formEditGroup,
      },
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.updateGroup(form.formEditGroup, masterDeviceDetails.id);
    }
  };

  return (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <Form onSubmit={handleUpdateGroup}>
        <FormGroup>
          <Label>
            Group Name<span className="text-danger">*</span>
          </Label>
          <Input
            autoFocus
            type='text'
            name="groupName"
            paceholder="Enter group name"
            onChange={AddGroupChange}
            value={form && form.formEditGroup && form.formEditGroup.groupName}
            invalid={form && form.errors && form.errors.groupName}
          />
          <FormFeedback>{form && form.errors && form.errors.groupName}</FormFeedback>
        </FormGroup>
      </Form>
      <FormGroup>
        <Button
          type="submit"
          className='me-4'
          size='sm'
          color="success"
          onClick={handleUpdateGroup}
        >
          Update
        </Button>
        <Button
          size='sm'
          color="danger"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </FormGroup>
    </Fragment>
  );

}

const mapStateToProps = (state) => ({
  form: state.form.form,
  isPending: state.deviceDetails.isUpdateGroupPending,
  errorMessage: state.deviceDetails.updateGroupErrorMessage,
  masterDeviceDetails: state.deviceDetails.masterDevice,
  currentProfile: state.deviceDetails.currentProfile,
  selectedGroup: state.deviceDetails.selectedGroup,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (EditGroup) => dispatch(updateForm(EditGroup)),
  getAssignableGroupsForAsyncSelect: (masterDeviceId, searchValue, callback) =>
    dispatch(getAssignableGroupsForAsyncSelect(masterDeviceId, searchValue, callback)),
  updateGroup: (EditGroup, masterDeviceId) => dispatch(updateGroup(EditGroup, masterDeviceId)),
  clearUpdateGroupError: () => dispatch(clearUpdateGroupError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateGroupForm);
